import Vue from 'vue'
const components = require.context('../components', true, /\.vue$/)
components.keys().forEach((modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1").replace(/\/index$/, '')
  const com = components(modulePath).default
  Vue.component(moduleName, com)
})
